import xIcon from 'img/x.svg'
import 'css/components/dismiss-button.css'

const DismissButton = ({ onClick }) => {
    return (
        <button className="dismiss-button" onClick={onClick}>
            <img src={xIcon} alt="Dismiss" />
        </button>
    )
}

export default DismissButton;